import { Box, useTheme } from '@mui/material'
import { c100Tokens } from './c100-tokens'

const MONO = "'IBM Plex Mono', monospace"

// Rank movement vs the previous Carnivore 100: NEW for debuts, ▲n/▼n spots
// moved. Renders nothing when unchanged (delta 0) or on the inaugural list.
export default function RankBadge({
  rankDelta,
  isNew
}: {
  rankDelta: number | null
  isNew: boolean
}) {
  const theme = useTheme()
  const t = c100Tokens(theme)
  if (!isNew && (rankDelta === null || rankDelta === 0)) return null

  const up = !isNew && (rankDelta as number) > 0
  const color = isNew ? t.accent : up ? t.gain : t.loss
  const label = isNew ? 'NEW' : `${up ? '▲' : '▼'}${Math.abs(rankDelta as number)}`

  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        fontFamily: MONO,
        fontSize: 9.5,
        fontWeight: 600,
        letterSpacing: '0.06em',
        color,
        bgcolor: isNew ? t.faintAccentBg : `${color}1f`,
        border: `1px solid ${color}55`,
        borderRadius: '6px',
        px: '5px',
        py: '1px',
        lineHeight: 1.6,
        whiteSpace: 'nowrap',
        fontVariantNumeric: 'tabular-nums'
      }}
    >
      {label}
    </Box>
  )
}
